import { useState } from 'react';
import axios from 'axios';
import { Crown } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL;

export function AdminLogin({ onLogin }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError('');
    try {
      const { data } = await axios.post(`${API}/api/auth/login`, { email, password }, { withCredentials: true });
      localStorage.setItem('gr_admin_token', data.token);
      onLogin(data);
    } catch (err) {
      const d = err.response?.data?.detail;
      setError(typeof d === 'string' ? d : 'Login failed');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#07130A] px-6">
      <form onSubmit={submit} className="w-full max-w-sm border border-[#F5C542]/30 bg-black/40 p-8 backdrop-blur-xl" data-testid="admin-login-form">
        <div className="mb-6 flex items-center gap-3">
          <Crown className="h-6 w-6 text-[#F5C542]" />
          <h1 className="font-display text-xl uppercase tracking-[0.2em] text-[#F5C542]">Admin Login</h1>
        </div>
        <label className="mb-1 block text-xs uppercase tracking-[0.2em] text-[#A3A3A3]">Email</label>
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          data-testid="admin-email-input"
          className="mb-4 w-full border border-white/15 bg-black/60 px-3 py-2.5 text-sm text-white outline-none focus:border-[#F5C542]"
        />
        <label className="mb-1 block text-xs uppercase tracking-[0.2em] text-[#A3A3A3]">Password</label>
        <input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
          data-testid="admin-password-input"
          className="mb-5 w-full border border-white/15 bg-black/60 px-3 py-2.5 text-sm text-white outline-none focus:border-[#F5C542]"
        />
        {error && <p className="mb-4 text-sm text-red-400" data-testid="admin-login-error">{error}</p>}
        <button
          type="submit"
          disabled={busy}
          data-testid="admin-login-submit"
          className="w-full bg-[#F5C542] py-3 text-sm font-semibold uppercase tracking-[0.2em] text-black transition-colors hover:bg-[#FFDD75] disabled:opacity-50"
        >
          {busy ? 'Signing in…' : 'Sign In'}
        </button>
      </form>
    </div>
  );
}
